module.exports = __webpack_public_path__ + "assets/img/8617fb664425fd09fed343e391764911.svg";